(() => {
  'use strict';
  const valid = {
    usage: ['travail', 'moto', 'sport', 'froid'],
    kind: ['doudoune', 'gilet', 'veste', 'polaire'],
    fit: ['femme', 'homme']
  };
  const complete = answers => Object.entries(valid).every(([key, values]) => values.includes(answers?.[key]));
  const selectKey = answers => {
    if (!complete(answers)) return null;
    const suffix = answers.fit === 'femme' ? 'f' : 'h';
    if (answers.kind === 'doudoune') return 'celsius21';
    if (answers.kind === 'gilet') return answers.usage === 'travail' ? `traverse9-${suffix}` : 'ultra9';
    if (answers.kind === 'veste') return `sillage21-${suffix}`;
    return `boreal4-${suffix}`;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = {complete, selectKey};
  if (typeof document === 'undefined') return;
  const root = document.querySelector('[data-nh-advisor]');
  if (!root) return;
  const $ = selector => root.querySelector(selector);
  const questions = $('[data-advisor-questions]'), result = $('[data-advisor-result]');
  const form = $('[data-advisor-form]'), emailForm = $('#NHAdvisorEmail');
  const fields = [...root.querySelectorAll('[data-advisor-step]')];
  const next = $('[data-advisor-next]'), back = $('[data-advisor-back]');
  const error = $('[data-advisor-error]');
  const sessionKey = 'nh_advisor_selection_v1';
  const pendingKey = 'nh_advisor_pending_v1';
  const recapKey = 'nh_advisor_recap_v1';
  let step = 0, selected = null, answers = {}, loading = false, catalogPromise = null;
  const storage = {
    get(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch (_) {} },
    remove(key) { try { sessionStorage.removeItem(key); } catch (_) {} }
  };
  const requestRecap = async () => {
    let payload;
    try { payload = JSON.parse(storage.get(recapKey) || 'null'); } catch (_) { return; }
    if (!payload || Date.now() - payload.at > 3600000) { storage.remove(recapKey); return; }
    try {
      const response = await fetch('https://mailing.nineheat.com/api/selection-recap', {
        method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload),
        signal:AbortSignal.timeout(12000)
      });
      if (response.ok) storage.remove(recapKey);
    } catch (_) { /* Keep the request for one retry on the next visit. */ }
  };
  const getJson = async url => {
    const response = await fetch(url, {signal: AbortSignal.timeout(12000)});
    if (!response.ok) throw Error('catalogue_unavailable');
    return response.json();
  };
  const catalogue = () => {
    if (!catalogPromise) catalogPromise = getJson(root.dataset.catalogue).catch(e => { catalogPromise = null; throw e; });
    return catalogPromise;
  };
  const storeRoot = root.dataset.root || '/';
  const go = (index, focus = true) => {
    step = index;
    questions.hidden = false; result.hidden = true;
    root.classList.remove('is-result');
    fields.forEach((field, i) => {
      field.hidden = i !== step;
      field.disabled = i !== step;
    });
    back.hidden = step === 0;
    next.textContent = step === 2 ? 'Voir mon modèle' : 'Continuer';
    $('[data-advisor-progress]').textContent = `${['Votre quotidien', 'Votre tenue', 'Votre coupe'][step]} · ${step + 1} / 3`;
    error.hidden = true;
    if (focus) fields[step].querySelector('legend').focus({preventScroll: true});
  };
  const remember = () => storage.set(sessionKey, JSON.stringify({answers, at: Date.now()}));
  const showResult = async (success = false, focus = true) => {
    if (!complete(answers) || loading) return;
    loading = true; next.disabled = true; next.setAttribute('aria-busy', 'true');
    next.textContent = 'Votre sélection…'; error.hidden = true;
    try {
      const items = await catalogue();
      selected = items.find(item => item.key === selectKey(answers));
      if (!selected) throw Error('selection_unavailable');
      const product = await getJson(`${storeRoot}products/${selected.handle}.js`);
      const productUrl = `${storeRoot}products/${selected.handle}`;
      const image = $('[data-advisor-image]');
      image.src = product.featured_image || selected.image;
      image.alt = `${selected.category} 9HEAT ${selected.name}`;
      $('[data-advisor-name]').textContent = selected.name;
      $('[data-advisor-category]').textContent = `${selected.category}${selected.fit === 'mixte' ? ' · Coupe mixte' : ''}`;
      const reasons = {travail: 'Pour travailler dehors sans garder le froid en tête.', moto: 'Pour les départs tôt et les retours au frais.', sport: 'Pour profiter de la balade, y compris pendant les pauses.', froid: 'Pour les moments où vous attendez dehors et finissez par avoir froid.'};
      $('[data-advisor-reason]').textContent = reasons[answers.usage];
      $('[data-advisor-benefit]').textContent = selected.benefit;
      const currency = window.Shopify?.currency?.active || 'EUR';
      const price = new Intl.NumberFormat('fr-FR', {style:'currency', currency}).format(product.price / 100);
      $('[data-advisor-price]').textContent = `${product.price_varies ? 'À partir de ' : ''}${price}`;
      root.querySelectorAll('[data-advisor-product-link]').forEach(a => { a.href = productUrl; });
      $('[data-advisor-buy]').textContent = product.available ? 'Voir le modèle et choisir ma taille' : 'Voir les disponibilités du modèle';
      $('[data-advisor-discount]').href = `${storeRoot}discount/WINTER10?redirect=${encodeURIComponent(productUrl)}`;
      $('[data-advisor-capture]').hidden = success;
      $('[data-advisor-success]').hidden = !success;
      questions.hidden = true; result.hidden = false;
      root.classList.add('is-result');
      remember();
      if (success) {
        try { localStorage.setItem('nh_heat10_popup_converted_v1', '1'); } catch (_) {}
        storage.remove(pendingKey);
        requestRecap();
      }
      if (focus) $('[data-advisor-name]').focus({preventScroll: true});
      if (focus) root.scrollIntoView({block: 'start', behavior: 'auto'});
    } catch (_) {
      error.textContent = 'La sélection ne se charge pas pour le moment. Réessayez ou consultez les modèles avec le lien ci-dessous.';
      error.hidden = false;
    } finally {
      loading = false; next.disabled = false; next.removeAttribute('aria-busy'); next.textContent = 'Voir mon modèle';
    }
  };
  form.addEventListener('submit', event => {
    event.preventDefault();
    const radio = fields[step].querySelector('input:checked');
    if (!radio) { error.textContent = 'Choisissez la réponse qui vous correspond.'; error.hidden = false; return; }
    answers[radio.name] = radio.value;
    remember();
    if (step < 2) go(step + 1);
    else showResult();
  });
  back.addEventListener('click', () => go(Math.max(0, step - 1)));
  $('[data-advisor-restart]').addEventListener('click', () => { go(0); root.scrollIntoView({block:'start'}); });
  emailForm.addEventListener('submit', event => {
    if (!selected || !complete(answers)) { event.preventDefault(); return; }
    const tag = `nh-intent-v1:${Math.floor(Date.now() / 1000)}:${selected.handle}:${answers.usage}:guide`;
    $('[data-advisor-tags]').value = `newsletter,9heat-guide,heat10,${tag}`;
    const returnUrl = new URL(location.pathname, location.origin);
    for (const [key, value] of Object.entries(answers)) returnUrl.searchParams.set(`nh_${key}`, value);
    returnUrl.searchParams.set('nh_selection', 'success');
    emailForm.elements.return_to.value = returnUrl.pathname + returnUrl.search;
    remember(); storage.set(pendingKey, '1');
    storage.set(recapKey, JSON.stringify({email:emailForm.elements['contact[email]'].value,
      selection_tag:tag,request_id:crypto.randomUUID(),at:Date.now()}));
    // Native Shopify customer form retains CAPTCHA and consent processing.
  });
  const params = new URLSearchParams(location.search);
  try {
    const saved = JSON.parse(storage.get(sessionKey) || 'null');
    if (saved && Date.now() - saved.at < 86400000 && complete(saved.answers)) answers = saved.answers;
  } catch (_) {}
  const fromUrl = Object.fromEntries(Object.keys(valid).map(key => [key, params.get(`nh_${key}`)]));
  if (complete(fromUrl)) answers = fromUrl;
  for (const [name, value] of Object.entries(answers)) {
    const radio = form.querySelector(`input[name="${name}"][value="${value}"]`);
    if (radio) radio.checked = true;
  }
  go(0, false);
  const ownReturn = params.get('nh_selection') === 'success' && complete(fromUrl);
  const nativeSuccess = storage.get(pendingKey) === '1' && ($('[data-advisor-capture]').dataset.liquidSuccess === 'true' || params.get('customer_posted') === 'true');
  const hasErrors = Boolean($('[data-advisor-native-error]'));
  if (complete(answers)) {
    go(2, false);
    showResult(!hasErrors && (ownReturn || nativeSuccess), false);
  }
})();
